export const GOOGLE_DOMAIN_COOKIE_NAME = 'H32'

// H13 - www.google.com
